import React from 'react';
import NavBarSettingsContainer from "../../header/HeaderSettingsContainer";
import HeaderLoginContainer from "../../header/HeaderLoginContainer";

const ProfileViewHeader = () => {
    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark" role="navigation">
                <div className="container">
                    <ul className="nav navbar-nav flex-row justify-content-between ml-auto">
                        <NavBarSettingsContainer/>
                        <HeaderLoginContainer/>
                    </ul>
                </div>
            </nav>
        </>
    )
};
export default ProfileViewHeader;